import "./productSlider.scss";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import { Navigation, Thumbs } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import React from "react";
import Placeholder from "../../../assets/images/placeholder.gif";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Magnifier from "react-magnifier";
import { useEffect, useState, useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { FaYoutube, FaTiktok } from "react-icons/fa";



const ProductImagesSlider = (props) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [activeThumb, setActiveThumb] = useState(null);

  const getYoutubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const getTikTokId = (url) => {
    if (!url) return null;
    const match = url.match(/\/video\/(\d+)/);
    return match ? match[1] : null;
  };

  const videoUrl =
    props.item?.api?.videos?.map((v) => {
      return { video_url: v.url, type: "video" };
    }) || [];

  const youtubeLink = props.item?.api?.youtube_link;
  let embedVideo = [];

  if (youtubeLink) {
    if (youtubeLink.includes("tiktok.com")) {
      const tiktokId = getTikTokId(youtubeLink);
      if (tiktokId) {
        embedVideo.push({
          video_url: `https://www.tiktok.com/embed/v2/${tiktokId}`,
          type: "tiktok",
        });
      }
    } else {
      embedVideo.push({
        video_url: `${youtubeLink}${youtubeLink.includes("?") ? "&" : "?"}autoplay=1&mute=1`,
        type: "youtube",
      });
    }
  }

  const allUrl = [...videoUrl, ...props.images, ...embedVideo];

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    const narrow = window.innerWidth <= 767 || (window.matchMedia && window.matchMedia("(max-width: 767px)").matches);
    return narrow;
  });
  // state for mobile image popup
  const [modalImage, setModalImage] = useState(null);


  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => {
      const narrow = window.innerWidth <= 767;
      setIsMobile(narrow);
    };
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);


  const arrowStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    background: "transparent",
    border: "none",
    borderRadius: "50%",
    width: "44px",
    height: "44px",
    cursor: "pointer",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "45px",
    color: "#ff7a00",
    transition: "all 0.25s ease"
  };

  const onMouseEnter = (e) => {
    e.currentTarget.style.background = "rgba(255,122,0,0.1)";
    e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
  };

  const onMouseLeave = (e) => {
    e.currentTarget.style.background = "transparent";
    e.currentTarget.style.transform = "translateY(-50%) scale(1)";
  };


  return (
    <>
      <span style={{ display: "block", width: "100%", position: "relative" }}>
        <Swiper
          loop={true}
          spaceBetween={10}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          style={{
            border: "1px solid rgb(236 132 95 / 50%)",
            borderRadius: "6px",
            width: "100%",
            ...(isMobile ? { height: "clamp(420px, 75vh, 720px)" } : {}),

          }}
          autoHeight={isMobile}

          modules={[Navigation, Thumbs]}
          grabCursor={true}
          thumbs={{ swiper: activeThumb }}
          className={`product-images-slider myImgWidth ${isMobile ? "product-images-slider--mobile" : "my-2"
            }`}

        >
          {props.images &&
            props.images.length !== 0 &&
            allUrl.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  {item?.type === "video" ? (
                    <div>
                      <video
                        controls
                        autoPlay
                        style={{ height: "609px", width: "391px" }}
                        loading="lazy"
                      >
                        <source src={item.video_url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : item?.type === "youtube" || item?.type === "tiktok" ? (
                    <div
                      className="swiper-no-swiping"
                      style={{ height: isMobile ? "100%" : "609px", width: "100%" }}
                    >
                      <iframe
                        width="100%"
                        height="100%"
                        src={item.video_url}
                        title="Video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        style={{ pointerEvents: "auto" }}
                      ></iframe>
                    </div>
                  ) : (
                    // when on mobile we allow click to open a standalone image
                    <div
                      className="mobile-magnifier-container"
                      onClick={(e) => {
                        if (isMobile) {
                          const srcValue =
                            item && typeof item == "string"
                              ? item
                              : item.original_image_url
                                ? item.original_image_url
                                : Placeholder;
                          setModalImage(srcValue);
                        }
                      }}
                      onTouchEnd={(e) => {
                        if (isMobile) {
                          const srcValue =
                            item && typeof item == "string"
                              ? item
                              : item.original_image_url
                                ? item.original_image_url
                                : Placeholder;
                          setModalImage(srcValue);
                        }
                      }}
                    >
                      <Magnifier
                        key={
                          item && typeof item === "string"
                            ? item
                            : item && item.original_image_url
                              ? item.original_image_url
                              : item && item.video_url
                                ? item.video_url
                                : undefined
                        }
                        className="setHeight"
                        /* on mobile fill parent, on desktop keep reasonable fixed height so the magnifier logic works */
                        height={isMobile ? "100%" : "30em"}
                        src={
                          item && typeof item == "string"
                            ? item
                            : item.original_image_url
                              ? item.original_image_url
                              : Placeholder
                        }
                        width="100%"
                        onClick={() => {
                          if (isMobile) {
                            const srcValue =
                              item && typeof item == "string"
                                ? item
                                : item.original_image_url
                                  ? item.original_image_url
                                  : Placeholder;
                            setModalImage(srcValue);
                          }
                        }}
                        onTouchEnd={(e) => {
                          // also respond to touch events
                          if (isMobile) {
                            const srcValue =
                              item && typeof item == "string"
                                ? item
                                : item.original_image_url
                                  ? item.original_image_url
                                  : Placeholder;
                            setModalImage(srcValue);
                          }
                        }}
                      />
                    </div>
                  )}
                </SwiperSlide>
              );
            })}
        </Swiper>

        <button
          ref={prevRef}
          style={{ ...arrowStyle, left: "10px" }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className="swiper-button-prev-custom"
        >
          <FiChevronLeft />
        </button>
        <button
          ref={nextRef}
          style={{ ...arrowStyle, right: "10px" }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className="swiper-button-next-custom"
        >
          <FiChevronRight />
        </button>
        {/* modal overlay should sit outside the Swiper components to avoid being clipped */}
        {modalImage && (
          <div
            className="image-modal"
            onClick={() => setModalImage(null)}
          >
            <img src={modalImage} alt="enlarged" />
          </div>
        )}
        <Swiper
          onSwiper={setActiveThumb}
          loop={true}
          spaceBetween={10}
          style={{
            width: "auto",
            maxWidth: "100%",
            margin: "8px auto 0",
            borderRadius: "6px",
          }}
          slidesPerView={
            props.images.length === 1 ? 1 : props.images.length === 2 ? 2 : 3
          }
          modules={[Navigation, Thumbs]}
          className="product-images-slider-thumbs"
        >
          {/* end of main slider */}

          {props &&
            props.images &&
            props.images.length !== 0 &&
            allUrl.map((item, index) => (
              <div key={index}>
                <SwiperSlide key={index}>
                  {item?.type === "video" ? (
                    <div>
                      <video
                        loading="lazy"
                        style={{ height: "117px", width: "91px" }}
                      >
                        <source src={item.video_url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : item?.type === "youtube" ? (
                    <div
                      style={{
                        width: "100%",
                        paddingBottom: "150%",
                        position: "relative",
                        background: "#f00",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                        }}
                      >
                        <FaYoutube size={40} />
                      </div>
                    </div>
                  ) : item?.type === "tiktok" ? (
                    <div
                      style={{
                        width: "100%",
                        paddingBottom: "150%",
                        position: "relative",
                        background: "#000",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                        }}
                      >
                        <FaTiktok size={35} />
                      </div>
                    </div>
                  ) : (
                    <LazyLoadImage
                      onLoad={() => props.imageLoad()}
                      src={
                        item && typeof item == "string"
                          ? item
                          : item.original_image_url
                            ? item.original_image_url
                            : Placeholder
                      }
                      style={{ display: "block", width: "100%" }}
                      alt="product images"
                    />
                  )}
                </SwiperSlide>
              </div>
            ))}
        </Swiper>
      </span>
    </>
  );
};
ProductImagesSlider.propTypes = {
  images: PropTypes.array.isRequired,
};
export default ProductImagesSlider;